import {
  DialogSurfaceProps,
  mergeClasses,
  Popover,
  PopoverSurface,
  PopoverTrigger,
  toMountNodeProps,
} from "@fluentui/react-components";
import { memo, ReactElement, useCallback, useState } from "react";
import { IDocument } from "../../interfaces";
import { DocumentReaderApp } from "../../pages/DocumentReaderApp";
import { useDocumentReaderStyles } from "./styles";

export type DocumentReaderProps = {
  document: IDocument;
  textBlock?: string;
  surfaceClassName?: string;
  trigger: ReactElement;
  onClose?: () => void;
};

export const DocumentReader = memo((props: DocumentReaderProps & Pick<DialogSurfaceProps, "mountNode">) => {
  const styles = useDocumentReaderStyles();

  const [open, setOpen] = useState<boolean>(true);
  const mountNodeProps = toMountNodeProps(props.mountNode);
  mountNodeProps.className = mergeClasses(styles.surface, props.surfaceClassName);

  const onOpenChange = useCallback((state: boolean) => {
    setOpen(state);
    if (!state) {
      props.onClose?.();
    }
  }, []);

  return (
    <Popover open={open && !!props.document} onOpenChange={(_ev, data) => onOpenChange(data.open)}>
      <PopoverTrigger disableButtonEnhancement>{props.trigger}</PopoverTrigger>
      <PopoverSurface className={mergeClasses(styles.surface, props.surfaceClassName)}>
        <DocumentReaderApp
          doc={props.document}
          textBlock={props.textBlock}
          onClose={() => onOpenChange(false)}
        />
      </PopoverSurface>
    </Popover>
  );
});
